// START ECH JQUERY FUNCTIONS & INIT FOR PLUGINS
(function ($) {
  
  // Burger Menu Functions
  function finished() {
    $(".navbar-toggle").addClass("finished");
  }
  function closeFinished() {
    $("#navBarText").empty().text("MENU");
    $(".navbar-toggle").removeClass("finished");
    $(".navbar-toggle").removeClass("active");
    $("#header").removeClass("finished");
  }
  // Menu click event
  $(".navbar-toggle").on("click", function (e) {
    if (!$(this).hasClass("active")) {
      $(this).addClass("active");
      $("#header").addClass("finished");

      var menuTl = new TimelineMax();
      menuTl
        .to(".main-menu", 0.5, { right: 0, ease: Power2.easeOut }, 0)
        .staggerTo(
          ".main-menu .menu-main-menu-container ul li",
          0.8,
          { opacity: 1, ease: Power2.easeOut },
          0.08,
          "myLabel"
        )
        .add(finished, "myLabel+=0.25");

      $("#navBarText").empty().text("CLOSE");
    } else if ($(this).hasClass("finished")) {
      var menuCloseTl = new TimelineMax();
      menuCloseTl
        .to(
          ".main-menu .menu-main-menu-container ul li",
          0.4,
          { opacity: 0, ease: Power2.easeOut },
          0
        )
        .to(".main-menu", 0.35, { right: "-100%", ease: Power2.easeIn }, 0.15)
        .add(closeFinished);
    }
  });

  // Back to Top Click
  $(".backtotop").on("click", function (e) {
    $(document.body).animate({
      scrollTop: 0,
    });
    e.preventDefault();
  });

  // Open links
  const currentHost = window.location.host;
  $('a[href]').each(function() {
    const $link = $(this);
    const href = $link.attr('href');
    // Skip if href is anchor, mailto, or tel
    if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) {
      return;
    }
    // Use URL constructor to resolve relative and absolute URLs
    const linkHost = new URL(href, window.location.origin).host;
    if (linkHost !== currentHost) {
      $link.attr('target', '_blank');
    }
  });

  // open in new window if external or pdf
  $(
    ".container a[href$='pdf'],.container a[href$='doc'],.container a[href$='docx'],.container a[href$='xls'],.container a[href$='xlsx']"
  ).attr("target", "_blank");
})(jQuery);
